<template lang="pug">
  validation-provider.row.membership-field-row(v-slot="{ errors }" :rules="{required: required && isBlank(membership_value)}")
    .form-col.large-12
      .field
        label(:class="{error: errors[0]}")
          span.required(v-if="required") *
          | {{t('app.registration.membership.membership')}}
          span(v-if="isPresent(description)")
            br
            small {{ description }}
          .field
            .select.multi(@click.stop.prevent="open_multi", :class="{'open': open_multi_mem, disabled: !entitySelected}")
              span.selected
                span.value(v-if="!member_attrs") {{ t('app.registration.membership.click_here') }}
                span.value(v-else-if="member_attrs.id") {{member_attrs.value }}
                span.value(v-else) {{t('app.registration.membership.create_new')}}
                span.caret
              ul.multi-select-option
                li(v-for="mem in memberships",
                  @click="chooseMember(mem)"
                  v-html="memberTitle(mem)"
                )
                li(@click="chooseMember({creator_type: 'User', value: ''})") {{t('app.registration.membership.create_new')}}
                input(
                  v-model="member_attrs.value",
                  :placeholder="t('app.registration.membership.enter_membership')",
                  type="text",
                  :required="required"
                  :disabled="!entitySelected"
                  @input="membershipChanged=true"
                )
            
      .field(v-if="member_attrs && (!member_attrs.id || changeable(member_attrs))")
        label
          span.float-placeholder(:class="{'active': membershipChanged}") {{t('app.registration.membership.enter_membership')}}
          input(
            v-model="member_attrs.value",
            :placeholder="t('app.registration.membership.enter_membership')",
            type="text",
            :required="required"
            :disabled="!entitySelected"
            @input="membershipChanged=true"
          )
</template>
<script>
import Approval from 'images/icons/approval.svg'
export default{
  props: {
    value: {type: Object, required: false}, // can be null
    entitySelected: {type: [Number,Boolean], required: true},
    required: {type: Boolean, required: false},
    description: {type: String, required: false}, //can be null
  },
  emits: {
    input: {}
  },
  data() {
    return {
      open_multi_mem: false,
      memberships: [],
      membershipChanged: false,
      member_attrs: {value: ""}
    }
  },
  computed: {
    organization_id() { return this.state.current_reg.program.organization.id },
    membership_value(){ return (this.member_attrs||{}).value },
  },
  watch: {
    value(){
      this.member_attrs = this.value
    },
    membershipChanged(){
      this.chooseMember(this.member_attrs)
    },
  },
  mounted(){
    this.loadMemberships()
  },
  methods: {
    open_multi(event) {
      event.preventDefault()
      if (!this.entitySelected) return
      this.open_multi_mem = !this.open_multi_mem
    },
    chooseMember(member){
      // this.member_attrs = member
      this.$emit("input", member)
      this.$emit("change", member)
    },
    changeable(member){ return !this.from_org(member)},
    from_org(member){ return member.creator_type === "Organization" },
    memberTitle(member){
      let str = ""
      if (this.from_org(member)){
        str += this.t("app.registration.membership.title_in_model",
            {
              creator_name:           this.$sanitize(member.creator_name),
              first_participant_name: this.$sanitize(member.first_participant_name),
              value:                  this.$sanitize(member.value),
              date: this.time_from(member.created_at, "MM/DD/YYYY")
            })
        str += `<span class='approved'><img src="${Approval}"></span>`
      }else{
        str += `<span>${this.$sanitize(member.value)}</span>`
      }
      return str
    },
    async loadMemberships(){
      const person_id = this.state.current_reg.person_id
      if (person_id < 1) return;

      this.state.current_reg.memberships || (this.state.current_reg.memberships = {})
      if (!this.state.current_reg.memberships[person_id]) { // doing caching to load only once
        const way = this.state.current_org.id ? "organization" : "family"
        try {
          const res = await this.axios.get(`/api2/${way}/memberships.json`, {
            params:
                {
                  organization_id: this.organization_id,
                  person_id: person_id,
                }
          })
          this.state.current_reg.memberships[person_id] = res.data.object
        } catch (err) {
          console.log(err)
        }
      }

      this.memberships = this.state.current_reg.memberships[person_id]
      this.chooseMember(this.memberships[0] || {})
    },
  }
}
</script>